/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!***********************************************!*\
  !*** ./src/js/hero-promo-mmm-results-2026.js ***!
  \***********************************************/
/**
 * Match my Makeup results row for the 'Hero - 2026 Promo' section.
 * Exposes document.MMMWidget.showProductLines / matchShade, which Match my Makeup calls with the matched lines.
 */
(function () {
  var container = document.querySelector('[data-mmm-results]');
  if (!container) return;
  var cards = Array.prototype.slice.call(container.querySelectorAll('[data-mmm-card]')),
      grid = container.querySelector('[data-mmm-results-grid]'),
      controls = container.querySelector('[data-mmm-results-controls]'),
      previousButtons = Array.prototype.slice.call(container.querySelectorAll('[data-mmm-prev]')),
      nextButtons = Array.prototype.slice.call(container.querySelectorAll('[data-mmm-next]')),
      bySku = {};
  var userScrolled = false,
      lineOrder = {},
      matchTrigger = null;
  document.MMMWidget = document.MMMWidget || {};
  /*
      The row is rendered inside the hero section, so Liquid alone cannot put another section between
      the two. Moving the node is the only way to let something like the trust ticker sit in between,
      which is why the row's styles are not scoped to the hero.
  */

  (function placeResults() {
    if (container.getAttribute('data-mmm-results-position') !== 'after_next') return;
    var heroSection = container.closest('.hero-promo-2026-section'),
        nextSection = heroSection && heroSection.nextElementSibling;
    if (!nextSection) return;
    nextSection.insertAdjacentElement('afterend', container);
  })();
  /*
      Match my Makeup replays a stored match on load, and does so well after the page has settled.
      Scrolling the row into view on that replay drags the shopper off wherever they are, so only a
      match they asked for in this session earns the scroll. Captured, so it still registers when the
      widget stops the click from bubbling.
       Trusted presses only, so a widget opened by script rather than by the shopper cannot arm the
      scroll. It also keeps the record on the button actually pressed, since a proxy opens the widget
      by clicking the primary and that second click is script made.
  */


  document.addEventListener('click', function (event) {
    if (!event.isTrusted) return;
    var trigger = event.target && event.target.closest && event.target.closest('[data-mmm-action]');
    if (trigger) matchTrigger = trigger;
  }, true); //Either button scrolls, so long as this match is one the shopper just asked for. The widget keeps a
  //shopper's match and replays it on load, and that replay has no press behind it, so a reload shows
  //the row where it is rather than jumping the page down to it.

  function shouldScrollToResults() {
    return Boolean(matchTrigger && matchTrigger.isConnected);
  }

  cards.forEach(function (card) {
    var source = card.querySelector('[data-mmm-variants]');
    if (!source) return;
    var index;

    try {
      index = JSON.parse(source.textContent || '{}');
    } catch (error) {
      return;
    }

    Object.keys(index).forEach(function (sku) {
      bySku[sku] = {
        card: card,
        variant: index[sku]
      };
    });
  }); //One visible card plus the row's gap.

  function scrollStep() {
    var card = grid.querySelector('[data-mmm-card]:not(.hidden)');
    if (!card) return grid.clientWidth;
    return card.offsetWidth + (parseFloat(window.getComputedStyle(grid).columnGap) || 0);
  } //Arrows only earn their place once the row overflows.


  function updateControls() {
    var scrollable = grid.scrollWidth - grid.clientWidth > 1;
    if (controls) controls.style.display = scrollable ? '' : 'none';
    previousButtons.forEach(function (button) {
      button.disabled = !scrollable || grid.scrollLeft <= 1;
    });
    nextButtons.forEach(function (button) {
      button.disabled = !scrollable || grid.scrollLeft >= grid.scrollWidth - grid.clientWidth - 1;
    });
  } //Cards reveal one match at a time, so hold the row at the first card until the shopper moves it.


  function resetScroll() {
    if (!userScrolled) grid.scrollLeft = 0;
  }

  previousButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      userScrolled = true;
      grid.scrollBy({
        left: -scrollStep(),
        behavior: 'smooth'
      });
    });
  });
  nextButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      userScrolled = true;
      grid.scrollBy({
        left: scrollStep(),
        behavior: 'smooth'
      });
    });
  });
  ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (type) {
    grid.addEventListener(type, function () {
      userScrolled = true;
    }, {
      passive: true
    });
  });
  grid.addEventListener('scroll', updateControls);
  window.addEventListener('resize', updateControls); //Points the card's links at the matched shade.

  function setVariantLinks(card, variantId) {
    Array.prototype.forEach.call(card.querySelectorAll('a[href]'), function (link) {
      var href = link.getAttribute('href');
      if (href.indexOf('/products/') === -1) return;
      link.setAttribute('href', href.split('?')[0] + '?variant=' + variantId);
    });
  } //Mirrors the card update the quick view performs when a shade is chosen.


  function setVariant(card, variant, hexRgb) {
    var input = card.querySelector('form [name="id"]'),
        title = card.querySelector('[data-variant-title]'),
        selector = card.querySelector('[data-quick-view]'),
        addToBag = card.querySelector('[data-atc-button]'),
        soldOut = card.querySelector('[data-oos-button]'),
        available = variant[1] === 1;
    if (input) input.value = variant[0];
    if (title) title.textContent = variant[2];
    if (addToBag) addToBag.classList.toggle('hidden', !available);
    if (soldOut) soldOut.classList.toggle('hidden', available);
    var swatch = card.querySelector('[data-variant-swatch-image]');

    if (!swatch && title) {
      swatch = document.createElement('span');
      swatch.className = 'w-6 h-6 shrink-0 rounded-lg';
      swatch.setAttribute('data-variant-swatch-image', '');
      title.parentNode.insertBefore(swatch, title);
    }

    if (swatch && /^[0-9a-f]{6}$/i.test(hexRgb || '')) {
      swatch.textContent = '';
      swatch.style.backgroundColor = '#' + hexRgb;
    } //The shade is fixed to the match, so the selector is display only.


    if (selector) {
      selector.disabled = true;
      selector.classList.remove('hover:bg-white');
      var chevron = selector.querySelector('[aria-hidden="true"]');
      if (chevron) chevron.hidden = true;
    }

    setVariantLinks(card, variant[0]);
  } //Called by Match my Makeup with the eligible product lines.


  document.MMMWidget.showProductLines = function (productLines) {
    var lines = productLines || [];
    lineOrder = {};
    cards.forEach(function (card) {
      card.classList.add('hidden');
      card.style.order = '';
    });
    lines.forEach(function (line, position) {
      lineOrder[line.id] = position;
      document.MMMWidget.matchShade(line.id);
    });
    container.hidden = true;
    userScrolled = false;
    resetScroll();
    updateControls();
  }; //Requests the matched shade for one product line.


  document.MMMWidget.matchShade = function (productLineId) {
    if (typeof document.MMMWidget.performMatch !== 'function') return;
    document.MMMWidget.performMatch(productLineId, function (product) {
      var sku = product && product.sku && product.sku[0],
          entry = sku ? bySku[sku] : null;
      if (!entry) return;
      setVariant(entry.card, entry.variant, product.hexRgb);
      entry.card.classList.remove('hidden');
      entry.card.style.order = lineOrder[productLineId] === undefined ? '' : lineOrder[productLineId];

      if (container.hidden) {
        container.hidden = false; //Cleared either way, so a later replay cannot inherit the shopper's earlier click.

        if (shouldScrollToResults()) container.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        matchTrigger = null;
      }

      resetScroll();
      updateControls();
    });
  };
})();
/******/ })()
;